import { MediasLogo } from "~/features/navigation/components/TopBar/MediasLogo";
import { trackRegisterInAffiliate } from "~/app/analytics/ga/affiliate";
import { redirectToUrl } from "~/utils/url/urlUtils";
import { REGISTER_PAGE } from "~/utils/url/staticUrls";
import { IconType } from "~/common/components/icon/IconType";

import classes from "~/features/affiliate/components/AffiliateSalesPartnerBanner/components/AffiliateRegisterBanner.module.less";
import classNames from "classnames";
import { useTranslation } from "react-i18next";
import { Permission, userHasPermission } from "~/domains/user/utils/permissions";
import { useIsMinPhoneSize } from "~/common/hooks/useMediaQuery";
import { selectVisitedAffiliate } from "~/domains/affiliate/redux/selectors";
import { useSelector } from "react-redux";
import { Button } from "~/common/mui";
import { DefaultButtonIcon } from "~/common/components/icon/Icon";

interface Props {
  className?: string;
}

export const AffiliateRegisterBanner = ({ className }: Props) => {
  const { t } = useTranslation();
  const partner = useSelector(selectVisitedAffiliate);
  const isMobile = useIsMinPhoneSize();

  return (
    <div className={classNames(classes.containerGray, className)}>
      <MediasLogo variant={"plus"} className={classes.logo} />
      <div className={classes.separator} />
      <p className={classes.text}>
        {userHasPermission(Permission.ADD_TO_CART)
          ? t("affiliateSalesPartner.banner.new.text.register")
          : t("affiliateSalesPartner.banner.text.register")}
      </p>
      <Button
        className={classNames(classes.button, !isMobile && "mt-3")}
        onClick={() => {
          trackRegisterInAffiliate(partner?.name ?? "");
          redirectToUrl(REGISTER_PAGE);
        }}
        data-test-id={"banner-partner-register"}
        startIcon={<DefaultButtonIcon type={IconType.User} />}
      >
        {t("affiliateSalesPartner.banner.button.registerForFree")}
      </Button>
    </div>
  );
};
